import type { CbiFrontendServiceContext } from "../../frontend/context/CbiFrontendServiceContext";
import type { CatalogDiscountInstanceRef } from "./CatalogDiscountInstanceRef";
import type { CatalogDiscountInstanceStaff } from "./CatalogDiscountInstanceStaff";
import type { DiscountType } from "./DiscountType";
import type { LineItemDiscountAmountsBase } from "./LineItemDiscountAmountsBase";
import type { LineItemDiscountInstanceDTOBase } from "./LineItemDiscountInstanceDTOBase";
import type { LineItemStaff } from "./LineItemStaff";
import type { TrackedModernBase } from "./TrackedModernBase";

export class LineItemDiscountInstanceStaff implements LineItemDiscountInstanceDTOBase, TrackedModernBase, LineItemDiscountAmountsBase {
  constructor(public readonly assignId: number, public readonly isAutoAddProcessed: boolean | null, public readonly createdOn: Date | null, public readonly createdBy: string | null, public readonly updatedOn: Date | null, public readonly updatedBy: string | null, public readonly discountType: DiscountType, public readonly isApplied: boolean | null, public readonly isAutoApplied: boolean | null, public readonly isUnapplied: boolean | null, public readonly specifiedCents: number | null, public readonly specifiedPercent: string | null, public readonly amountBaseCents: number | null, public readonly amountTotalCents: number | null, public readonly universalCode: string | null, public readonly lineItemId: LineItemStaff | null, public readonly discountInstanceId: CatalogDiscountInstanceStaff | null, public readonly discountInstanceIdTargetIds: CatalogDiscountInstanceRef) {
    this.cbiServiceContext = null;
    this.lineItemIdLoaded = this.lineItemId != null;
    this.lineItemIdCached = this.lineItemId;
    this.discountInstanceIdLoaded = this.discountInstanceId != null;
    this.discountInstanceIdCached = this.discountInstanceId;
  }
  cbiServiceContext: CbiFrontendServiceContext | null;
  private lineItemIdLoaded: boolean;
  private lineItemIdCached: LineItemStaff | null;
  private discountInstanceIdLoaded: boolean;
  private discountInstanceIdCached: CatalogDiscountInstanceStaff | null;
  async lineItemIdLazy(): Promise<LineItemStaff> {
    if (!this.lineItemIdLoaded) {
      this.lineItemIdCached = await this.cbiServiceContext!.orderService().getLineItemDiscountInstanceStaffLineItemId(this.assignId);
      this.lineItemIdLoaded = true;
    }
    return this.lineItemIdCached!;
  }
  async discountInstanceIdLazy(): Promise<CatalogDiscountInstanceStaff> {
    if (!this.discountInstanceIdLoaded) {
      this.discountInstanceIdCached = await this.cbiServiceContext!.discountService().getCatalogDiscountInstanceStaff(this.discountInstanceIdTargetIds.instanceId);
      this.discountInstanceIdLoaded = true;
    }
    return this.discountInstanceIdCached!;
  }
}
